import MetaTags from '../components/common/MetaTags'

export default function AboutPage() {
  return (
    <>
      <MetaTags
        title="About | profile.work"
        description="Learn about profile.work - the modern platform for creating professional online profiles and resumes."
      />
      <div className="py-16 sm:py-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
              About profile.work
            </h1>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              We believe everyone deserves a professional online presence. profile.work makes it
              easy to create beautiful, shareable profiles that showcase your skills, experience,
              and achievements.
            </p>

            <div className="mt-12 space-y-12">
              <section>
                <h2 className="text-2xl font-bold text-gray-900">Our Mission</h2>
                <p className="mt-4 text-gray-600 leading-7">
                  Our mission is to democratize professional branding. Whether you're a developer,
                  designer, marketer, or any other professional, you should have access to tools
                  that help you present yourself in the best light possible.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900">What We Offer</h2>
                <ul className="mt-4 space-y-4 text-gray-600">
                  <li className="flex gap-3">
                    <svg
                      className="h-6 w-6 flex-shrink-0 text-indigo-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <span>
                      <strong>Custom Subdomain:</strong> Get your own personalized URL like
                      yourname.profile.work
                    </span>
                  </li>
                  <li className="flex gap-3">
                    <svg
                      className="h-6 w-6 flex-shrink-0 text-indigo-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <span>
                      <strong>Beautiful Templates:</strong> Choose from professionally designed
                      templates that make you stand out
                    </span>
                  </li>
                  <li className="flex gap-3">
                    <svg
                      className="h-6 w-6 flex-shrink-0 text-indigo-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <span>
                      <strong>AI-Powered Resume Parsing:</strong> Upload your resume and we'll
                      automatically extract your information
                    </span>
                  </li>
                  <li className="flex gap-3">
                    <svg
                      className="h-6 w-6 flex-shrink-0 text-indigo-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <span>
                      <strong>Theme Customization:</strong> Personalize colors and fonts to match
                      your personal brand
                    </span>
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900">Get Started</h2>
                <p className="mt-4 text-gray-600 leading-7">
                  Creating your profile takes just minutes. Sign up for free and start building your
                  professional presence today.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
